<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$emit('update:show', false)"
  >
    <el-table
      class="ui-table"
      :header-cell-class-name="tableHeaderCellClassName"
      :cell-class-name="tableContentCellClassName"
      style="margin-bottom: 20px;"
      border
      :data="list"
    >
      <slot slot></slot>
    </el-table>
    <el-pagination
      background
      :hide-on-single-page="true"
      layout="prev, pager, next"
      :page-size="paginationConfig.pageSize"
      :total="paginationConfig.total"
      @current-change="handleCurrentChange"
      style="margin-bottom:20px;"
      v-if="isPagination"
    ></el-pagination>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    paginationConfig: {
      type: Object,
      default: () => {
        return {
          page: 1,
          pageSize: 10,
          total: 0
        };
      }
    },
    isPagination: {
      type: Boolean,
      default: false
    },
    tableHeaderCellClassName: {
      type: Function,
      default: ({ row, column, rowIndex, columnIndex }) => {
        return "";
      }
    },
    tableContentCellClassName: {
      type: Function,
      default: ({ row, column, rowIndex, columnIndex }) => {
        return "";
      }
    }
  },
  data() {
    return {
      visible: this.show
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.paginationConfig.page = index;
      this.query.page = index.toString();
      this.$emit("getList");
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  }
};
</script>
<style scoped>
</style>
